module.exports = __webpack_public_path__ + "img/dark-mud-decal-25.ebae626d.png";